import { createReducer } from 'reduxsauce'
import { Types } from '../actions/nfceActions'

const INITIAL_STATE = { error: false, loading: false, postos: null }

const begin = (state = INITIAL_STATE, action) => {
    return { ...state, error: false, loading: true, postos: null }
}
const success = (state = INITIAL_STATE, action) => {
    return { ...state, error: false, loading: false, postos: action.postos }
}
const failure = (state = INITIAL_STATE, action) => {
    return { ...state, error: action.error, loading: false, postos: null }
}

const HANDLERS = {
    [Types.FETCH_CONFERENCIA_NFCE_BEGIN]: begin,
    [Types.FETCH_CONFERENCIA_NFCE_SUCCESS]: success,
    [Types.FETCH_CONFERENCIA_NFCE_FAILURE]: failure
}

export default createReducer(INITIAL_STATE, HANDLERS)